/**
 * Cache-buster for the signed-in user's own avatar. The IdP serves avatars
 * at a stable URL (`/avatars/{id}`), so after an upload/removal the browser
 * cache must be skipped once — bumping the version appends a fresh `?v=`.
 *
 * `srcByUserId` holds the `blob:` object URLs published by
 * `services/avatarCache.js` (desktop only); `UserAvatar` prefers one over the
 * network URL when present.
 */
import { create } from 'zustand';

export const useAvatarStore = create((set) => ({
  version: 0,
  bumpAvatarVersion: () => set((s) => ({ version: s.version + 1 })),
  srcByUserId: {},
  setAvatarSrc: (userId, src) =>
    set((s) => {
      const key = String(userId);
      if (s.srcByUserId[key] === src) return s; // no-op: same object → no notify
      return { srcByUserId: { ...s.srcByUserId, [key]: src } };
    }),
}));
